import React from "react";
import { LoginBox } from "../containers/LoginBox";

export const LoginPage = () => {
  return (
    <div>
      <LoginBox />
    </div>
  );
};
